import { VEICULO } from '../mutation-types';
import { Veiculo } from '../class/veiculo';

export const moduleVeiculo = {
    state: {
        list: new Map(),
    },
    mutations: {
        [VEICULO.SET_ONE] (state, veiculo) {
            state.list.set(veiculo.id_veiculo, veiculo);
        }
    },
    actions: {
        async [VEICULO.BY_PK] ({commit}, id) {
            let veiculo = await Veiculo.byPK(id);
            if (veiculo) {
                commit(VEICULO.SET_ONE, veiculo);
            }
        }
    }
};
